import React, { useEffect } from "react";
import { connect } from "react-redux";

import {
  getGlobalIaac,
  clearAllGlobalIaacMessages
} from "../store/actions";

import { Alert } from "reactstrap";

import accessToken from "../helpers/jwt-token-access/accessToken";
import { jwtDecode } from "jwt-decode";
import GlobalIaaC from "./GlobalIaaC";
import EditGlobalIaaC from "./EditGlobalIaaC";

import spinner from "../assets/images/loadingGif.gif";

const GlobalIaaCManager = (props) => {
  //For userRole identification
  const token = accessToken();
  const decoded = jwtDecode(token);
  const userRole = decoded["cognito:groups"];

  const iaac = props?.iaac;
  useEffect(() => {
    if(!iaac) {
      props.getGlobalIaac();
    }  
  }, [iaac]);


  //For displaying message for getting License
  let getGlobalIaacMessage = props.getGlobalIaacMessage;
  let getGlobalIaacError = props.getGlobalIaacError;
  useEffect(() => {
    console.log("getGlobalIaacMessage = " + getGlobalIaacMessage);
    if (getGlobalIaacMessage || getGlobalIaacError) {
      console.log("Inside if, getGlobalIaacMessage = " + getGlobalIaacMessage);
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [getGlobalIaacMessage, getGlobalIaacError, props]);

  //For displaying message for getting License
  let updateGlobalIaacMessage = props.updateGlobalIaacMessage;
  let updateGlobalIaacError = props.updateGlobalIaacError;
  useEffect(() => {
    console.log("updateGlobalIaacMessage = " + updateGlobalIaacMessage);
    if (updateGlobalIaacMessage || updateGlobalIaacError) {
      console.log("Inside if, updateGlobalIaacMessage = " + updateGlobalIaacMessage);
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
    if(updateGlobalIaacMessage){
      props.clearAllMessages();
      props.getGlobalIaac();
    }
  }, [updateGlobalIaacMessage, updateGlobalIaacError, props]);
  

  return (
    <div style={{marginTop:"10px",marginLeft: "auto", marginRight: "auto", width: "800px"}}>
      {props.getGlobalIaacMessage && (
        <Alert className="mt-3 mb-0" color="success">
          {props.getGlobalIaacMessage}
        </Alert>
      )}
      {props.getGlobalIaacError && (
        <Alert className="mt-3 mb-0" color="danger">
          Error while getting License information.
          {JSON.stringify(props.getGlobalIaacError)}
        </Alert>
      )}
      {props.updateGlobalIaacMessage && (
        <Alert className="mt-3 mb-0" color="success">
          {props.updateGlobalIaacMessage}
        </Alert>
      )}
      {props.updateGlobalIaacError && (
        <Alert className="mt-3 mb-0" color="danger">
          Error while getting License information.
          {JSON.stringify(props.updateGlobalIaacError)}
        </Alert>
      )}

      {props.isGettingGlobalIaac && (
        <div
          style={{
            display: "flex",
            direction: "column",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            justifyItems: "center",
            height: "100vh",
          }}
        >
          <img src={spinner} width="32px" alt="Spinner" />
        </div>
      )}

      {iaac && (
        <div>
          <div
            style={{
              justifyContent: "center",
              display: "flex",
              flexWrap: "wrap",
              marginTop: "10px",
            }}
          >
            <h5 style={{ color: "blue" }}>Global IaaC Management</h5>
          </div>
          <div>
            <GlobalIaaC iaac={iaac}/>
          </div>
        </div>
      )}

      {iaac && (
        <div>
          <div
            style={{
              justifyContent: "center",
              display: "flex",
              flexWrap: "wrap",
              marginTop: "30px",
            }}
          >
            <h5 style={{ color: "blue" }}>Edit Global IaaC</h5>
          </div>
          <div>
            <EditGlobalIaaC iaac={iaac}/>
          </div>
        </div>
      )}
    </div>
  );

}

const mapStateToProps = (state) => {
  const {
    isGettingGlobalIaac,
    getGlobalIaacMessage,
    getGlobalIaacError,
    iaac,

    updateGlobalIaacMessage,
    updateGlobalIaacError

  } = state.globalIaac;
  return {
    isGettingGlobalIaac,
    getGlobalIaacMessage,
    getGlobalIaacError,
    iaac,

    updateGlobalIaacMessage,
    updateGlobalIaacError
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getGlobalIaac: () => {
      dispatch(getGlobalIaac());
    },
    clearAllMessages: () => {
      dispatch(clearAllGlobalIaacMessages());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GlobalIaaCManager);